import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { useState } from 'react';
import VideoPlayerBase, * as VideoPlayer from '@segment/matcha/components/VideoPlayer';
import Elevation from '@segment/matcha/components/Elevation';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

var Video = function Video(_ref) {
  var data = _ref.data;
  var url = data.url;

  var _useState = useState(false),
      playing = _useState[0],
      setPlaying = _useState[1];

  var play = function play() {
    return setPlaying(true);
  };

  var stop = function stop() {
    return setPlaying(false);
  };

  return _jsx(StyledElevation, {
    elevation: 2,
    type: "dropShadow",
    children: _jsx(VideoPlayerBase, {
      url: url,
      playing: playing,
      onPause: stop,
      onPlay: play,
      children: !playing && _jsx(VideoPlayer.BigPlayButton, {
        ariaLabel: "Play Button",
        onClick: play
      })
    })
  });
};

var StyledElevation = /*#__PURE__*/_styled(Elevation, true ? {
  target: "ewdbmur0"
} : {
  target: "ewdbmur0",
  label: "StyledElevation"
})(true ? {
  name: "5ogka4",
  styles: "margin:64px 0"
} : {
  name: "5ogka4",
  styles: "margin:64px 0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvUmljaFRleHQvVmlkZW8udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQStCeUMiLCJmaWxlIjoiL3dvcmtkaXIvbGlicy9tYXRjaGEvcmVjaXBlcy9SaWNoVGV4dC9WaWRlby50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IEZDLCBQcm9wc1dpdGhDaGlsZHJlbiB9IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHsgdXNlU3RhdGUgfSBmcm9tICdyZWFjdCdcblxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmltcG9ydCBWaWRlb1BsYXllckJhc2UsICogYXMgVmlkZW9QbGF5ZXIgZnJvbSAnQHNlZ21lbnQvbWF0Y2hhL2NvbXBvbmVudHMvVmlkZW9QbGF5ZXInXG5cbmltcG9ydCBFbGV2YXRpb24gZnJvbSAnQHNlZ21lbnQvbWF0Y2hhL2NvbXBvbmVudHMvRWxldmF0aW9uJ1xuXG5leHBvcnQgaW50ZXJmYWNlIFZpZGVvUHJvcHMge1xuICBkYXRhOiB7XG4gICAgdXJsOiBzdHJpbmdcbiAgfVxufVxuXG5jb25zdCBWaWRlbzogRkM8UHJvcHNXaXRoQ2hpbGRyZW48VmlkZW9Qcm9wcz4+ID0gKHsgZGF0YSB9KSA9PiB7XG4gIGNvbnN0IHsgdXJsIH0gPSBkYXRhXG5cbiAgY29uc3QgW3BsYXlpbmcsIHNldFBsYXlpbmddID0gdXNlU3RhdGUoZmFsc2UpXG4gIGNvbnN0IHBsYXkgPSAoKSA9PiBzZXRQbGF5aW5nKHRydWUpXG4gIGNvbnN0IHN0b3AgPSAoKSA9PiBzZXRQbGF5aW5nKGZhbHNlKVxuXG4gIHJldHVybiAoXG4gICAgPFN0eWxlZEVsZXZhdGlvbiBlbGV2YXRpb249ezJ9IHR5cGU9XCJkcm9wU2hhZG93XCI+XG4gICAgICA8VmlkZW9QbGF5ZXJCYXNlIHVybD17dXJsfSBwbGF5aW5nPXtwbGF5aW5nfSBvblBhdXNlPXtzdG9wfSBvblBsYXk9e3BsYXl9PlxuICAgICAgICB7IXBsYXlpbmcgJiYgPFZpZGVvUGxheWVyLkJpZ1BsYXlCdXR0b24gYXJpYUxhYmVsPVwiUGxheSBCdXR0b25cIiBvbkNsaWNrPXtwbGF5fSAvPn1cbiAgICAgIDwvVmlkZW9QbGF5ZXJCYXNlPlxuICAgIDwvU3R5bGVkRWxldmF0aW9uPlxuICApXG59XG5cbmNvbnN0IFN0eWxlZEVsZXZhdGlvbiA9IHN0eWxlZChFbGV2YXRpb24pYFxuICBtYXJnaW46IDY0cHggMDtcbmBcblxuZXhwb3J0IGRlZmF1bHQgVmlkZW9cbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default Video;